import React from 'react'
import { ExecuteOperationOnPipe, Form, Model, WhenLoaded } from '@morningtrain/react-resources'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import EmploymentSmartviewWrapper from 'pages/app/hr/employments/smartviews/EmploymentSmartviewWrapper'
import EditEmploymentForm from 'pages/app/hr/employments/partials/EditEmploymentForm'
import EmploymentSmartview from 'pages/app/hr/employments/smartviews/EmploymentSmartview'
import * as Fields from 'support/fields'

export default function ReactivateEmploymentSmartview ({ id }) {
  return (
          <Form route="api.employments.employment.store">
            <MountSmartviewOnPipe
                    smartview={payload => <EmploymentSmartview id={payload.response.model.id}/>}
                    replace={false}
            />
            <ExecuteOperationOnPipe namespace="api" operationName="index" resourceName="employments.employment"
                                    operationContext={{ context: 'employment-index' }}/>
            <Model resourceName="employments.employment" id={id}>
              <Fields.Hidden name="reactivate" defaultValue={true}/>
              <WhenLoaded>
                <EmploymentSmartviewWrapper size="3xl" editing={true} isEdit={true} showFooter={false}>
                  <EditEmploymentForm/>
                </EmploymentSmartviewWrapper>
              </WhenLoaded>
            </Model>
          </Form>
  )
}
